<template>
    <div class="col-lg-9 mx-auto overflow-x-hidden">
        <header class="text-center mb-4">
            <h2 class="skin-page-heading">
                Support
            </h2>

            <p v-if="schemeInfo" class="px-3">
                Here are the support options available to you in the {{ schemeInfo.name }}.
            </p>
        </header>

        <div class="container-fluid">
            <FinalSalarySchemeSupport v-if="schemeInfo" :schemeSupportMode="schemeInfo.supportMode"></FinalSalarySchemeSupport>

            <hr class="my-5 mx-5">

            <div v-if="schemeHasContactDetails">
                <p class="fw-bold">For questions about your Scheme benefits</p>

                <p class="mb-3">If you have questions about your benefits under the Scheme, please contact the Scheme Administrators using the details below:</p>

                <p v-if="schemeWebsite">Website: <a :href="schemeWebsite" target="_blank">{{ schemeWebsite }}</a></p>

                <p v-if="schemeEmail">Email: {{ schemeEmail }}</p>

                <p v-if="schemePhoneNo">Phone number: {{ schemePhoneNo }}</p>

                <div v-if="schemeAddress.length">
                    <p class="mb-2">Address:</p>
                    <p v-for="(p, i) of schemeAddress" :key="i" class="ms-2 mb-0 fst-italic">{{ p }}</p>
                </div>

                <hr class="my-5 mx-5">
            </div>

            <div>
                <p class="fw-bold">For general information about pensions and retirement</p>
                <p>
                    <a href="https://www.moneyhelper.org.uk" target="_blank">MoneyHelper</a> is an independent service set up by the Government to help people
                    make the most of their money. It provides information about financial planning and saving, including information about the different types
                    of financial advice available, where to look for an FCA regulated financial adviser and the questions to ask them.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, watch } from "vue";
    import { useStore } from "vuex";
    import FinalSalarySchemeSupport from "@/guiide/components/common/DBOptions/FinalSalarySchemeSupport.vue";
    import FinalSalaryScheme from "@/guiide/ts/assets/finalsalary/finalSalaryScheme";
    import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

    const { text, textArray } = useUIContent();

    const store = useStore();

    const schemeInfo = ref<FinalSalaryScheme | null>(null);

    const schemeWebsite = ref<string | null>(text('dboptions.scheme.contact.website'));
    const schemeEmail = ref<string | null>(text('dboptions.scheme.contact.email'));
    const schemePhoneNo = ref<string | null>(text('dboptions.scheme.contact.phone-number'));
    const schemeAddress = ref<string[] | null>(textArray('dboptions.scheme.contact.address'));

    const schemeHasContactDetails = computed(() =>
        [schemeWebsite.value, schemeEmail.value, schemePhoneNo.value, schemeAddress.value.length].some(Boolean)
    );

    watch(
        () => store.state.retiree,
        async () => {
            await getScheme();
        }
    );

    async function getScheme() {
        if (!store.state.retiree) {
            return;
        }

        schemeInfo.value = store.state.retiree.finalSalaries?.schemes[0];
    }
</script>
